import { Disclosure } from "@headlessui/react";
import type { PropsWithChildren } from "react";

import AccordionButton from "./AccordionButton";
import AccordionPanel from "./AccordionPanel";

interface AccordionProps extends PropsWithChildren<{}> {}

const Accordion = ({ children }: AccordionProps) => {
	return (
		<Disclosure>
			<>{children}</>
		</Disclosure>
	);
};

Accordion.Button = AccordionButton;
Accordion.Panel = AccordionPanel;

export default Accordion;
